import React from "react";

const PagerHero = ({
  headline = "Powering the Future",
  description = "Delivering advanced solutions for projects in Energy Sector worldwide - nuclear facilities, data center energy infrastructure, oil & gas, energy / building efficiency, energy community solutions.",
}) => {
  const streams = [10, 25, 40, 55, 70, 85];

  return (
    <section className="tech-grid-hero">
      <div className="stream-bg">
        {streams.map((left, index) => (
          <div
            key={index}
            className="stream"
            style={{ left: `${left}%` }}
          ></div>
        ))}
      </div>

      <div className="secondary-hero-content">
        <h1>{headline}</h1>
        <p>{description}</p>
      </div>
    </section>
  );
};

export default PagerHero;
